const CHECK_INTERVAL_MS = 60_000;

let loadedVersion: string | null = null;
let lastCheckAt: number | null = null;

async function fetchDeployedVersion(): Promise<string | null> {
  try {
    const response = await fetch(import.meta.env.BASE_URL, {
      method: 'HEAD',
      cache: 'no-store',
    });
    return response.ok ? response.headers.get('last-modified') : null;
  } catch {
    return null;
  }
}

export async function isNewVersionDeployed(): Promise<boolean> {
  if (lastCheckAt !== null && Date.now() - lastCheckAt < CHECK_INTERVAL_MS) {
    return false;
  }
  lastCheckAt = Date.now();
  const deployedVersion = await fetchDeployedVersion();
  if (!deployedVersion) {
    return false;
  }
  loadedVersion ??= deployedVersion;
  return deployedVersion !== loadedVersion;
}
